import axios from "axios";
import { baseUrl } from "../config/endPoints";
import keycloak from "./keycloak";

const API_KEY = process.env.REACT_APP_API_KEY;

const authAxios = axios.create({
  baseURL: baseUrl,
});

authAxios.interceptors.request.use(
  (config) => {
    config.params = {
      ...config.params,
      api_key: API_KEY,
    };
    if (keycloak.token) {
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

authAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      keycloak.login({
        redirectUri: window.location.origin + window.location.pathname + '#/search',
      });
    }
    return Promise.reject(error);
  }
);

export default authAxios;
